/* =====================================================================
   Bailey & Beau Co. — Home page interactions
   ===================================================================== */

/**
 * Handles the contact / newsletter form submissions.
 * Prevents a real navigation, gives lightweight "Sent" feedback,
 * and resets the form.
 * @param {Event} e
 * @param {HTMLFormElement} form
 * @returns {boolean}
 */
function handleSubmit(e, form) {
  e.preventDefault();

  const label = form.querySelector('[data-label]');
  if (label) {
    const original = label.textContent;
    label.textContent = 'Sent ✓';
    form.reset();
    setTimeout(function () {
      label.textContent = original;
    }, 2200);
  }
  return false;
}

// Expose for inline onsubmit handlers in the markup.
window.handleSubmit = handleSubmit;

/* =====================================================================
   Mobile / tablet menu drawer
   Each hero renders its own `.bb-nav-root`, so wire every instance
   independently rather than relying on a single shared id.
   ===================================================================== */
(function () {
  function init() {
    var roots = document.querySelectorAll('.bb-nav-root');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var drawer = root.querySelector('.bb-mm');
      var openBtn = root.querySelector('.bb-mm-open');
      if (!drawer || !openBtn) return;

      var closeBtn = drawer.querySelector('.bb-mm-close');
      var backdrop = drawer.querySelector('.bb-mm-backdrop');

      function open() {
        drawer.classList.add('is-open');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('bb-mm-locked');
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        drawer.classList.remove('is-open');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('bb-mm-locked');
        openBtn.focus();
      }

      openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (backdrop) backdrop.addEventListener('click', close);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });

      // Close when the viewport grows past the lg breakpoint (desktop nav takes over)
      var desktop = window.matchMedia('(min-width: 1024px)');
      var onBreakpoint = function (e) {
        if (e.matches && drawer.classList.contains('is-open')) close();
      };
      if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
      else if (desktop.addListener) desktop.addListener(onBreakpoint);

      // Collapsible submenus
      drawer.querySelectorAll('.bb-mm-sub').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var list = btn.closest('li').querySelector('.bb-mm-sublist');
          if (!list) return;
          var isOpen = list.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =====================================================================
   Decorative particles — recolor each shape at a random 2–5s cadence
   ===================================================================== */
(function () {
  var palettes = {
    vivid: ['#F26B59', '#F0C75E', '#46AFCE', '#9E7DBB', '#C84A70', '#41BA85'],
    light: ['#FFFFFF', '#F0C75E', '#7FD3E8', '#F26B59', '#E59BC0', '#FBE0A8'],
  };

  function pick(arr, exclude) {
    var c;
    do { c = arr[Math.floor(Math.random() * arr.length)]; }
    while (c === exclude && arr.length > 1);
    return c;
  }

  function start() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var parts = document.querySelectorAll('.deco');
    parts.forEach(function (p) {
      var pal = palettes[p.dataset.palette] || palettes.vivid;
      // seed an initial colour immediately so there's no flash
      p.style.color = pick(pal);
      if (reduce) return;
      (function loop() {
        var delay = (2 + Math.floor(Math.random() * 4)) * 1000; // 2,3,4 or 5s
        setTimeout(function () {
          p.style.color = pick(pal, p.style.color);
          loop();
        }, delay);
      })();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
